import { render, staticRenderFns } from "./AddAttribute.vue?vue&type=template&id=3ee27525&"
import script from "./AddAttribute.vue?vue&type=script&lang=js&"
export * from "./AddAttribute.vue?vue&type=script&lang=js&"
import style0 from "./AddAttribute.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports